import niceClient from '@/plugins/axios/niceClient'
import { snakeCaseKeys } from '@/util'

export default {
  /**
   *
   * @param {
   *   id: businessLicenseNumber,
   *   business_license_number: businessLicenseNumber,
   *   company_name: companyName,
   *   firebase_token: firebaseToken,
   *   promotion_code: promotionCode
   * } data
   * @returns
   */
  postUsers(data) {
    return niceClient.post('/v1/users', snakeCaseKeys(data))
  },
}
